/** The mapping from media to channels. */
export const mediaToChannels = {
    email: ['email', 'contact_form'],
    interactivechat: ['widget_chat', 'messenger'],
    speak: ['voicemail', 'callback', 'pstn_phone'],
    messaging: ['facebook_messenger', 'whats_app', 'telegram', 'sms', 'twitter'],
};
/** Represents various channel specific attributes and configurations. */
export const channelAttributes = {
    callback: { icon: 'phone-plus', name: 'Callback' },
    pstn_phone: { icon: 'phone', name: 'Phone' },
    voicemail: { icon: 'voicemail', name: 'Voicemail' },
    contact_form: {
        icon: 'chat-widget',
        name: 'Contact form',
        contentType: 'html',
        editor: {
            sanitizationProfile: 'email',
        },
    },
    email: {
        icon: 'mail',
        name: 'Email',
        contentType: 'html',
        editor: {
            sanitizationProfile: 'email',
        },
    },
    facebook_messenger: {
        icon: 'facebook-messenger',
        name: 'Facebook Messenger',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'plainText',
        },
    },
    messenger: {
        icon: 'messenger',
        name: 'Messenger',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'email',
        },
    },
    sms: {
        icon: 'sms',
        name: 'Text',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'plainText',
        },
    },
    telegram: {
        icon: 'cog',
        name: 'Telegram',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'plainText',
        },
    },
    twitter: {
        icon: 'twitter',
        name: 'Twitter',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'plainText',
        },
    },
    whats_app: {
        icon: 'whatsapp',
        name: 'WhatsApp',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'whatsApp',
        },
    },
    widget_chat: {
        icon: 'chat',
        name: 'Chat',
        contentType: 'text',
        editor: {
            sanitizationProfile: 'widgetChat',
        },
    },
};
/**
 * Gets the media of a channel.
 *
 * @param channel The channel.
 */
export function getChannelMedia(channel) {
    const channelMedia = Object.keys(mediaToChannels).find((media) => mediaToChannels[media].includes(channel));
    if (channelMedia)
        return channelMedia;
    throw Error(`Media not found, a channel should always belong to a media. (${channel})`);
}
/**
 * Gets the readable name of a channel.
 *
 * @param channel The channel.
 * @returns The readable name of the channel.
 */
export function getChannelName(channel) {
    return channelAttributes[channel].name;
}
